import { graphql } from '@api/generated';
import { getClient } from '@api/client';
import { SearchParams as CustomerSearchParams } from '../components/CustomerSearchBox/CustomerSearchBox';

export const getCustomerBySearchQuery = graphql(`
  query getCustomerBySearch($tenantId: ID, $where: CustomerFilterInput) {
    customers(tenantId: $tenantId, where: $where) {
      items {
        id
        name
        contacts {
          id
          type
          value
          memo
          jobRemindersEnabled
          marketingUpdatesEnabled
          invoiceStatementNotification
        }
        type
        locations {
          id
          active
          name
          address {
            street
            unit
            city
            state
            zip
            country
          }
        }
        tenant {
          id
          name
        }
        doNotService
      }
    }
  }
`);

async function searchCustomers(
  searchParams: CustomerSearchParams,
  tenantId?: string,
) {
  const { data, error } = await getClient().query({
    query: getCustomerBySearchQuery,
    variables: { tenantId, where: searchParams },
    fetchPolicy: 'network-only',
  });

  if (error) {
    throw new Error(error.message);
  }

  return data?.customers?.items || [];
}

export default searchCustomers;
